<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("add") }} {{ $t("voucher") }}</div>
      <router-link class="btn-blue" to="vouchers"
        >{{ $t("voucher") }} {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="row">
          <div class="col-lg-4 col-xl-3 mb-1">
            <div class="input-material">
              <!-- <input
                v-model="vouchersObject.voucher_code"
                v-validate="{required: 'required'}"
                name="voucher_code"
                id="voucher_code"
                placeholder="."

                type="text"
              />-->
              <input
                v-model="vouchersObject.voucher_code_list[0]"
                v-validate="{ required: 'required' }"
                name="voucher_code"
                id="voucher_code"
                placeholder="."
                type="text"
              />
              <!-- this.voucher_code_list -->
              <label>{{ $tc("code") }}</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_code')">{{
                errors.first("voucher_code")
              }}</span>
            </p>
          </div>

          <div class="col-lg-4 col-xl-3 mb-1">
            <div class="input-material">
              <input
                v-model="vouchersObject.voucher_title"
                v-validate="'required'"
                name="voucher_title"
                id="voucher_title"
                placeholder="."
                type="text"
              />
              <label>{{ $t("name") }}</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_title')">{{
                errors.first("voucher_title")
              }}</span>
            </p>
          </div>

          <div class="col-lg-4 col-xl-3 mb-1">
            <div class="input-material d-flex align-items-center">
              <input
                v-model="vouchersObject.voucher_receipt_name"
                name="voucher_receipt_name"
                id="voucher_receipt_name"
                placeholder="."
                type="text"
                v-b-tooltip.hover
                :title="$t('info')"
              />
              <label>{{ $t("Receipt") }} {{ $t("inprint") }}</label>
              <!--Tooltip :title="$t('info')" /-->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_receipt_name')">{{
                errors.first("voucher_receipt_name")
              }}</span>
            </p>
          </div>

          <div
            class="col-lg-4 col-xl-3 align-self-center mb-1"
            style="padding-bottom:15px;"
          >
            <div class="d-flex align-items-center justify-content-center">
              <b-form-checkbox
                class="ml-3 j-checkbox pb-0"
                v-model="vouchersObject.voucher_is_active"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{
                vouchersObject.voucher_is_active === "Y" ? "Active" : "Deactive"
              }}</span>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-lg-4 col-xl-6 mb-1">
            <div class="input-material-textarea">
              <textarea
                v-model="vouchersObject.voucher_description"
                placeholder="."
                rows="3"
              ></textarea>
              <label class="shift-"
                >{{ $t("voucher") }} {{ $t("usedfor") }}</label
              >
            </div>
          </div>

          <div :class="['my-3', 'col-lg-12 col-xl-12']">
            <div class="d-flex align-self-center">
              <strong>1.&nbsp;</strong>
              <b-form-checkbox
                class="j-checkbox pb-0 ml-3"
                v-model="vouchersObject.voucher_for_specific_seat_type"
                @input="onChangeCinemaSpecificValue"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <div>
                {{ $t("applicableforselectedcinemasclassesntickettypes") }}
              </div>
            </div>
            <b-collapse
              :visible="vouchersObject.voucher_for_specific_seat_type === 'Y'"
            >
              <div
                class="pt-2"
                v-if="vouchersObject.voucher_for_specific_seat_type === 'Y'"
              >
                <div
                  v-for="(Item,
                  ItemsIndex) in vouchersObject.selectedCinemasList"
                  :key="ItemsIndex"
                  class="row back_white mb-2 pt-2 mx-1"
                >
                  <div class="col-lg-6 col-xl-3 mb-xl-0">
                    <custommultiselect
                      v-model="Item.cine_id"
                      :options="Cinemas"
                      @input="getScreenList($event, ItemsIndex)"
                      :placeholder="$tc('Cinemas')"
                      label="cine_name"
                      isSingleId="cine_id"
                      :multiple="false"
                      track-by="cine_id"
                    ></custommultiselect>
                  </div>

                  <div class="col-lg-6 col-xl-2 mb-xl-0">
                    <custommultiselect
                      v-model="Item.screen_id"
                      :options="Item.screenList"
                      @input="getSeatClassList($event, ItemsIndex)"
                      :placeholder="$tc('screens')"
                      label="screen_name"
                      isSingleId="screen_id"
                      :multiple="false"
                      track-by="screen_id"
                    ></custommultiselect>
                  </div>

                  <div class="col-lg-6 col-xl-3">
                    <custommultiselect
                      v-model="Item.sst_id"
                      :options="Item.seatClassList"
                      :placeholder="$tc('Seat Class')"
                      label="sst_seat_type"
                      isSingleId="sst_id"
                      :multiple="false"
                      track-by="sst_id"
                    ></custommultiselect>
                  </div>
                  <!-- SELECT TICKET TYPE -->
                  <div class="col-md-3 mb-2">
                    <div class="d-flex align-items-center">
                      <custommultiselect
                        v-model="Item.tt_id"
                        :options="TicketTypes"
                        label="tt_name"
                        track-by="tt_id"
                        isSingleId="tt_id"
                        :placeholder="$tc('TicketType')"
                        :multiple="false"
                        v-b-tooltip.hover
                        :title="$t('selectTicketType')"
                      />
                    </div>
                  </div>
                  <div class="col-xl-1">
                    <!-- <button
                      v-if="ItemsIndex == 0"
                      class="btn-transparent mb-3"
                      @click="addMoreCinemasScreenSeatClass()"
                    >
                      <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                    </button> -->

                    <button
                      class="btn-transparent mb-3"
                      @click="removeCinemasScreenSeatClass(ItemsIndex)"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
                <div
                  class="row d-flex align-items-center justify-content-center border-top mt-4 mb-5 position-relative"
                >
                  <button
                    @click.prevent.stop="addMoreCinemasScreenSeatClass()"
                    class="btn-transparent add-more-button"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </b-collapse>
          </div>

          <div
            v-if="vouchersObject.voucher_for_specific_seat_type === 'N'"
            :class="[
              'mb-1',
              cinemasList.length > 0 &&
              cinemasList[0].Cinemas.length > 0 &&
              cinemasList[0].Cinemas.length ===
                vouchersObject.selectedCinemasList.length
                ? 'col-lg-12 col-xl-12'
                : 'col-lg-6 col-xl-6',
            ]"
          >
            <!--<label :class="cinemasList.length > 0 ? 'shift-up' : '' ">{{ $tc('cinema', 1) }}</label>-->

            <div class="dropdown-curve-container">
              <label
                :class="
                  vouchersObject.selectedCinemasList.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("selectCinemas") }}</label
              >
              <div class="multiselect">
                <custommultiselect
                  v-model="vouchersObject.selectedCinemasList"
                  :options="cinemasList"
                  :placeholder="$tc('selectCinemas')"
                  label="cine_name"
                  :multiple="true"
                  track-by="cine_id"
                  group-values="Cinemas"
                  group-label="label"
                  :group-select="true"
                >
                  <!-- <template slot="tag" slot-scope="{ option }">
                    <span
                      >{{ option.cine_name }}
                      {{
                        vouchersObject.selectedCinemasList.length > 1
                          ? ","
                          : ""
                      }}&nbsp;</span
                    >
                  </template> -->
                </custommultiselect>
              </div>
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted && vouchersObject.selectedCinemasList.length == 0
                "
                >{{ $tc("select_user_Cinema") }}.</span
              >
            </p>
          </div>

          <div
            :class="[
              'mb-1',
              movieList.length > 0 &&
              movieList[0].Movies.length > 0 &&
              movieList[0].Movies.length ===
                vouchersObject.selectedMoviesList.length
                ? 'col-lg-12 col-xl-12'
                : 'col-lg-6 col-xl-6',
            ]"
          >
            <div class="dropdown-curve-container">
              <label
                :class="
                  vouchersObject.selectedMoviesList.length > 0 ? 'shift-up' : ''
                "
                >{{ $tc("movies") }}</label
              >
              <custommultiselect
                v-model="vouchersObject.selectedMoviesList"
                :options="movieList"
                :placeholder="$tc('movies')"
                label="movie"
                isSingleId="md_id"
                :multiple="true"
                track-by="md_id"
                group-values="Movies"
                group-label="label"
                :group-select="true"
              >
                <!-- <template slot="tag" slot-scope="{ option }">
                  <span>{{ option.movie }},&nbsp;</span>
                </template> -->
              </custommultiselect>
            </div>
            <p class="error_message">
              <!-- v-if="submitted && vouchersObject.selectedMoviesList.length == 0" -->
              <span></span>
            </p>
          </div>
        </div>

        <div class="row ">
          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button
                  class="btn-clearDate"
                  v-if="vouchersObject.voucher_start_date_time"
                  v-on:click="vouchersObject.voucher_start_date_time = null"
                >
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="vouchersObject.voucher_start_date_time"
                    type="date"
                    class="theme-custom-date-time  w-100"
                    typeable
                    id="voucher_startdate"
                    name="voucher_startdate"
                    v-validate="'required'"
                    :disabled-dates="disabledDates"
                    v-b-tooltip.hover
                    :title="$t('voucher_start_date_tooltip')"
                  ></Datepicker>
                  <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
                </div>
                <label
                  :class="
                    vouchersObject.voucher_start_date_time ? 'active' : ''
                  "
                  >{{ $t("startdate") }}</label
                >
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_startdate')">{{
                errors.first("voucher_startdate")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button
                  class="btn-clearDate"
                  v-if="vouchersObject.voucher_end_date_time"
                  v-on:click="vouchersObject.voucher_end_date_time = null"
                >
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="vouchersObject.voucher_end_date_time"
                    type="date"
                    class="theme-custom-date-time w-100"
                    typeable
                    id="voucher_enddate"
                    name="voucher_enddate"
                    v-b-tooltip.hover
                    :title="$t('voucher_end_date_tooltip')"
                  ></Datepicker>
                  <!--Tooltip :title="$t('voucher_end_date_tooltip')" /-->
                </div>
                <label
                  :class="vouchersObject.voucher_end_date_time ? 'active' : ''"
                  >{{ $t("enddate") }}</label
                >
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_enddate')">{{
                errors.first("voucher_enddate")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="d-flex justify-content-center align-items-center">
              <vue-timepicker
                manual-input
                v-model="vouchersObject.startTime2"
                id="starttime"
                name="starttime"
                :placeholder="$tc('starttime')"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-b-tooltip.hover
                :title="$t('voucher_start_time')"
              ></vue-timepicker>
              <!--Tooltip :title="$t('voucher_start_time')" /-->
            </div>
            <!-- <div class="input-material">
              <div class="add-datepicker">
                <date-picker
                v-model="vouchersObject.voucher_start_date_time"
                type="time"
                class="theme-custom-date-time"
                format="hh:mm a"
                lang="en"
                :minute-step="1"
                typeable
                v-validate="'required'"
                id="o_start_time"
              ></date-picker>
                <label class="active"
                  >{{ $t("offer") }} {{ $t("starttime") }}</label
                >
              </div>
            </div> -->
            <p class="error_message">
              <span v-if="submitted && errors.has('starttime')">{{
                errors.first("starttime")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="d-flex justify-content-center align-items-center">
              <vue-timepicker
                manual-input
                v-model="vouchersObject.endTime2"
                id="endtime"
                name="endtime"
                :placeholder="$tc('endtime')"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-b-tooltip.hover
                :title="$t('voucher_end_time')"
              ></vue-timepicker>
              <!--Tooltip :title="$t('voucher_end_time')" /-->
            </div>
            <!-- <div class="input-material">
              <div class="add-datepicker">
                <date-picker
                v-model="vouchersObject.voucher_end_date_time"
                type="time"
                class="theme-custom-date-time"
                format="hh:mm a"
                lang="en"
                :minute-step="1"
                typeable
                v-validate="'required'"
                id="o_start_time"
              ></date-picker>
                <label class="active"
                  >{{ $t("offer") }} {{ $t("endtime") }}</label
                >
              </div>
            </div> -->
            <p class="error_message">
              <span v-if="submitted && errors.has('endtime')">{{
                errors.first("endtime")
              }}</span>
            </p>
          </div>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 mb-4">
            <div class="input-material">
              <input
                v-model="vouchersObject.voucher_receipt_name"
                name="voucher_receipt_name"
                id="voucher_receipt_name"
                placeholder="."
                type="text"
              />
              <label>{{ $t("voucher") }} {{ $t("receipt_name") }}</label>
            </div>
          </div> -->

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class
                v-model="vouchersObject.is_code_required"
                unchecked-value="N"
                value="Y"
                switch
              ></b-form-checkbox>
              <span class="ml-3">{{ $t("Code Required") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class
                v-model="vouchersObject.is_share_with_distributor"
                unchecked-value="N"
                value="Y"
                switch
              ></b-form-checkbox>
              <span class="ml-3">{{ $t("Share With Distributor") }}</span>
            </div>
          </div> -->

        <div class="row" style="height:25px">
          <div
            class="col-lg-12 col-xl-12 align-self-center mb-4"
            v-if="vouchersObject.is_code_required == 'Y'"
          >
            <div class="d-flex align-items-center mb-2">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="vouchersObject.generateMultipleCode"
                @change="OnChangeMultipleCodeGenerate"
              ></b-form-checkbox>
              <span class="ml-1 ">{{ $t("generatemultiplecode") }}</span>
            </div>
          </div>
        </div>

        <b-collapse v-model="vouchersObject.generateMultipleCode">
          <div
            class="internal-border-new rounded-10 p-3 mb-2"
            style="background-color:white;"
          >
            <div class="row">
              <div class="col-md-2 mb-1">
                <div class="input-material">
                  <input
                    v-model="multipleVouchersCode.noOfVouchers"
                    placeholder="."
                    type="text"
                  />
                  <label>{{ $t("total") }} {{ $t("number") }}</label>
                </div>
              </div>

              <div class="col-md-2 mb-1">
                <div class="input-material">
                  <input
                    v-model="multipleVouchersCode.prefixText"
                    placeholder="."
                    type="text"
                  />
                  <label>{{ $t("enterPrefix") }}</label>
                </div>
              </div>

              <div class="col-md-3 align-self-center mb-1">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    :checked="this.multipleVouchersCode.isRandom"
                    @change="
                      () =>
                        (this.multipleVouchersCode.isRandom = !this
                          .multipleVouchersCode.isRandom)
                    "
                    class="j-checkbox"
                  ></b-form-checkbox>
                  <span class="ml-3">{{ $t("random") }}</span>
                </div>
              </div>
              <div class="col-md-2 align-self-center mb-1">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    :checked="!this.multipleVouchersCode.isRandom"
                    @change="
                      () =>
                        (this.multipleVouchersCode.isRandom = !this
                          .multipleVouchersCode.isRandom)
                    "
                    class="j-checkbox"
                  ></b-form-checkbox>
                  <span class="ml-3">{{ $t("sequence") }}</span>
                </div>
              </div>

              <div
                v-if="this.multipleVouchersCode.isRandom"
                class="col-md-2 mb-1"
              >
                <div class="input-material">
                  <input
                    v-model="multipleVouchersCode.voucherCodeLength"
                    placeholder="."
                    type="number"
                  />
                  <label>{{ $t("codelength") }}</label>
                </div>
              </div>

              <div
                v-if="!this.multipleVouchersCode.isRandom"
                class="col-md-3 mb-1"
              >
                <div class="input-material">
                  <input
                    v-model="multipleVouchersCode.sequenceStart"
                    placeholder="."
                    type="number"
                  />
                  <label>{{ $t("sequence") }} {{ $t("start") }}</label>
                </div>
              </div>

              <!-- <div class="col-md-4 d-flex align-items-center mb-3">
              <button
                @click.prevent.stop="onGenerateMultipleVouchers"
                class="btn-blue"
              >{{ $t('generate') }} {{ $t('voucher') }}</button>
            </div>-->
              <!-- <div
              v-if="vouchersObject.generateMultipleCode && this.vouchersObject.voucher_code_list.length > 1"
              class="col-md-4 d-flex align-items-center mb-3"
            >
              <button v-b-modal.view-voucher-codes-modal class="btn-blue">{{ $t('view') }}</button>
            </div>-->
            </div>
          </div>
        </b-collapse>
      </div>

      <div class="new-border rounded-10 p-3 mb-3 back">
        <div class="section-title mb-3" style="font-size: 20px">
          {{ $t("voucher") }} {{ $tc("setting", 2) }}
        </div>

        <div class="row" style="height:25px;">
          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="vouchersObject.is_code_required"
                unchecked-value="N"
                value="Y"
                class="j-checkbox pb-0"
                @change="onChangeCodeRequired"
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("is_code_required") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="vouchersObject.is_open_voucher"
                unchecked-value="N"
                value="Y"
                class="j-checkbox pb-0"
                @change="onchangeOpenVoucher($event)"
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("openVoucher") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="vouchersObject.is_share_with_distributor"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("is_share_with_distributor") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4" v-if="false">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="vouchersObject.add_in_revenue"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{ "Add in Revenue" }}</span>
            </div>
          </div>
        </div>
        <!--Collapse-->
        <b-collapse
          v-model="vouchersObject.is_open_voucher"
          v-if="vouchersObject.is_open_voucher == 'Y'"
        >
          <div
            class="d-flex internal-border-new mt-2"
            style="border-radius:10px;padding-top:10px;flex-wrap:wrap;background-color:white;"
          >
            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2"
              v-if="!hideComplemetory"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0"
                  v-model="vouchersObject.is_complimentary_ticket"
                  unchecked-value="N"
                  value="Y"
                  @change="handleComplimetoryChange"
                ></b-form-checkbox>
                <span class="ml-1">{{ $t("is_complimentary_ticket") }}</span>
              </div>
            </div>

            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2"
              v-if="
                vouchersObject.is_open_voucher == 'Y' &&
                  vouchersObject.is_complimentary_ticket == 'N'
              "
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0"
                  v-model="vouchersObject.is_allow_cash_refund"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="ml-1">{{ $t("allow_cash_refund") }}</span>
              </div>
            </div>

            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2 pt-4"
              v-if="
                !hideComplemetory &&
                  vouchersObject.is_complimentary_ticket == 'Y'
              "
            >
              <div class=" d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      vouchersObject.ticket_type_selected ? 'shift-up' : ''
                    "
                    >{{ $tc("ticketType") }}</label
                  >
                  <multiselect
                    v-model="vouchersObject.ticket_type_selected"
                    @select="selectTicketType($event)"
                    :options="TicketTypes"
                    label="tt_name"
                    track-by="tt_id"
                    placeholder=""
                    :multiple="false"
                    v-b-tooltip.hover
                    :title="$t('Ticket type')"
                  />
                </div>

                <!--Tooltip :title="$t('Ticket type')" /-->
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                      vouchersObject.is_complimentary_ticket == 'Y' &&
                      vouchersObject.ticket_type_selected.length == 0
                  "
                  >{{ messagetickettype }}</span
                >
              </p>
            </div>

            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2 pt-4"
              v-if="
                !hideComplemetory &&
                  vouchersObject.is_complimentary_ticket == 'Y'
              "
            >
              <div class=" d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      vouchersObject.selectedCinemaComplimentory
                        ? 'shift-up'
                        : ''
                    "
                    >{{ "Cinema" }}</label
                  >
                  <multiselect
                    v-model="vouchersObject.selectedCinemaComplimentory"
                    @select="onSelectComplimetoryCinema($event)"
                    :options="Cinemas"
                    label="cine_name"
                    track-by="cine_id"
                    placeholder=""
                    :multiple="false"
                    v-b-tooltip.hover
                    :title="$t('Cinema For Complemetory Ticket')"
                  />
                </div>

                <!--Tooltip :title="$t('Cinema For Complemetory Ticket')" /-->
              </div>
              <p class="error_message"></p>
            </div>

            <div
              class="col-lg-6 col-xl-3 align-self-center mb-2"
              v-if="
                !hideComplemetory &&
                  vouchersObject.is_complimentary_ticket == 'Y' &&
                  vouchersObject.selectedCinemaComplimentory
              "
            >
              <div class=" d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="vouchersObject.selectedScreen ? 'shift-up' : ''"
                    >{{ $tc("screen", 1) }}</label
                  >
                  <multiselect
                    v-model="vouchersObject.selectedScreen"
                    @select="onSelectScreen($event)"
                    :options="ScreenList"
                    label="screen_name"
                    track-by="screen_id"
                    placeholder=""
                    :multiple="false"
                    v-b-tooltip.hover
                    :title="$t('Screen For Complemetory Ticket')"
                  />
                </div>

                <!--Tooltip :title="$t('Screen For Complemetory Ticket')" /-->
              </div>
            </div>
          </div>
        </b-collapse>
        <!--Collapse-->
      </div>

      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="section-title  mb-4" style="font-size: 20px">
          {{ $t("voucher") }} {{ $tc("configuration", 1) }}
        </div>

        <div class="row" style="align-items:baseline;">
          <div
            class="col-lg-8 col-xl-8 align-self-center mb-2 align-items-center"
          >
            <div class="row mx-0">
              {{ $t("redeemAt") }}:
              <b-form-checkbox
                v-model="vouchersConfigation.vs_redeem_at_boxoffice"
                class="j-checkbox mx-3  pb-0"
                @change="onChangeReedem()"
              >
                <div class="text-capitalize">{{ $t("boxoffice") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                :disabled="isValueVoucher == 'N'"
                v-model="vouchersConfigation.vs_redeem_at_concession"
                class="j-checkbox mx-3  pb-0"
                @change="onChangeReedem()"
              >
                <div class="text-capitalize">{{ $t("concession") }}</div>
                <span class="text-muted fs-12">{{
                  isValueVoucher == "N" ? "(Not Applicable)" : ""
                }}</span>
              </b-form-checkbox>
              <b-form-checkbox
                v-if="vouchersObject.is_open_voucher != 'Y'"
                v-model="vouchersConfigation.vs_redeem_at_online"
                class="j-checkbox mx-3  pb-0"
                @change="onChangeReedem()"
              >
                <div class="text-capitalize">{{ $t("online") }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message" style="">
              <span>{{ $t(reedemerror) }}</span>
            </p>
          </div>

          <div
            class="d-flex mb-2 col-lg-4 col-xl-4 justify-content-center"
            v-if="showConfiguration"
          >
            <span>{{ $t("isValueVoucher") }}</span>
            <b-form-checkbox
              class="ml-3 j-checkbox pb-0"
              v-model="isValueVoucher"
              unchecked-value="N"
              @change="onChangeSwitch($event)"
              value="Y"
            ></b-form-checkbox>
          </div>
        </div>
        <div class="row">
          <div
            class="internal-border"
            v-if="vouchersObject.is_open_voucher == 'N'"
            style="background-color:white;"
          >
            <div
              v-if="isValueVoucher == 'N' && showConfiguration"
              class="col-lg-4 col-xl-4 align-self-center mb-1"
            >
              {{ $t("buyngetfreeticket") }}
              <div
                class="offer-content-wrapper"
                style="padding-left:0px;padding-top:15px"
              >
                <div class="row">
                  <div class="col-lg-12 col-xl-12 mb-3">
                    <div class="d-flex align-items-center">
                      {{ $t("buy") }}
                      <div class="input-material-sm mx-1">
                        <input
                          v-validate="'required|numeric'"
                          name="buy_ticket"
                          id="buy_ticket"
                          v-model="vouchersConfigation.voucher_buy_no_of_ticket"
                          type="text"
                        />
                      </div>
                      {{ $t("get") }}
                      <div class="input-material-sm mx-2">
                        <input
                          v-validate="'required|numeric'"
                          name="get_ticket"
                          id="get_ticket"
                          v-model="vouchersConfigation.voucher_get_free_ticket"
                          type="text"
                        />
                      </div>
                      {{ $t("ofticketsfree") }}
                    </div>
                  </div>
                </div>
              </div>
              <p class="error_message">
                <span
                  v-if="
                    (submitted && errors.has('buy_ticket')) ||
                      (submitted && errors.has('get_ticket'))
                  "
                  >{{
                    errors.first("buy_ticket") || errors.first("get_ticket")
                  }}</span
                >
              </p>
            </div>

            <!-- VOUCHER VALUE -->
            <div
              v-if="isValueVoucher == 'Y' && showConfiguration"
              class="col-lg-3 col-xl-2 align-self-center mb-1"
            >
              <div class="d-flex align-items-center">
                <span>{{ $tc("value") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align:right"
                    v-model="vouchersConfigation.voucher_amount"
                    v-validate="'required|numeric'"
                    name="voucher_amt"
                    id="voucher_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_amt')">{{
                  errors.first("voucher_amt")
                }}</span>
              </p>
            </div>

            <!-- IS PERCENTAGE -->
            <div
              v-if="isValueVoucher == 'Y' && showConfiguration"
              :class="
                vouchersConfigation.voucher_is_percentage == 'Y'
                  ? 'col-lg-3 col-xl-2 align-self-center mb-2'
                  : 'col-lg-3 col-xl-3 align-self-center mb-2'
              "
            >
              <div class="d-flex align-items-center">
                <span>{{ $t("Percentage") }}</span>
                <b-form-checkbox
                  class="ml-3 j-checkbox pb-0"
                  v-model="vouchersConfigation.voucher_is_percentage"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
              </div>
              <p class="error_message"></p>
            </div>

            <!-- MIN BILL AMOUNT  -->
            <div
              :class="
                vouchersConfigation.voucher_is_percentage == 'Y'
                  ? 'col-lg-6 col-xl-5 align-self-center mb-0'
                  : 'col-lg-6 col-xl-7 align-self-center mb-0'
              "
              v-if="showConfiguration"
              :style="isValueVoucher == 'N' ? 'padding-top:15px' : ''"
            >
              <div class="d-flex align-items-center">
                <span>{{ $tc("minBill_Redemption") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align:right"
                    v-model="vouchersConfigation.voucher_min_redemption_amount"
                    v-validate="'required|numeric'"
                    name="voucher_min_amt"
                    id="voucher_min_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_min_amt')">{{
                  errors.first("voucher_min_amt")
                }}</span>
              </p>
            </div>

            <!-- MAX BILL AMOUNT -->
            <div
              class="col-lg-3 col-xl-3 align-self-center mb-1"
              v-if="
                showConfiguration &&
                  vouchersConfigation.voucher_is_percentage == 'Y'
              "
              :style="isValueVoucher == 'N' ? 'padding-top:15px' : ''"
            >
              <div class="d-flex align-items-center">
                <span v-if="isValueVoucher == 'Y'"
                  >{{ $tc("Max") }} {{ $tc("discount") }}</span
                >
                <span v-else>{{ $t("maxfreeticketpertransaction") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align:right"
                    v-model="vouchersConfigation.voucher_max_redemption_amount"
                    name="voucher_max_amt"
                    id="voucher_max_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_max_amt')">{{
                  errors.first("voucher_max_amt")
                }}</span>
              </p>
            </div>
          </div>
          <!-- REDEEMABLE ON NET-VALUE / GROSS AMOUNT  -->
          <div
            class="col-lg-12 mb-4 d-flex align-items-center"
            v-if="showConfiguration"
          >
            <div>
              <span>{{ $tc("redeem") }} On :</span>
            </div>
            <div class="d-flex align-items-center">
              <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
              <b-form-radio
                value="voucherRedeemNetAmount"
                class="j-radio ml-2 pb-0"
                v-model="vouchersConfigation.voucherRedeemAmount"
              >
              </b-form-radio>
              <div>
                <span style="text-transform:capitalize;">{{
                  $tc("netAmount")
                }}</span>
              </div>
              <!---strong class="mx-3">OR</strong---->

              <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
              <b-form-radio
                value="voucherRedeemGrossAmount"
                class="j-radio ml-2 pb-0"
                v-model="vouchersConfigation.voucherRedeemAmount"
              >
                <div>
                  <span>{{ $tc("grossAmount") }}</span>
                </div>
              </b-form-radio>
            </div>
          </div>

          <div class="row col-12" style="margin-left:1px;">
            <div class="  align-self-center mb-4">
              <div class="d-flex align-items-center">
                <span>{{ $tc("voucherRedemptionperPatron") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align:right"
                    v-model="vouchersConfigation.voucher_redemption_per_patron"
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div class="  align-self-center mb-4">
              <div class="d-flex align-items-center">
                <span>Total {{ $tc("redemption") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align:right"
                    v-model="vouchersConfigation.voucher_total_redemption"
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div class="  align-self-center mb-4" v-if="showConfiguration">
              <div class="d-flex align-items-center">
                <span>{{ $tc("voucherRedemptionPercentageAtFNB") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align:right"
                    v-model="vouchersObject.voucher_redemption_percent_fnb"
                    type="number"
                    :min="0"
                    :max="100"
                  />
                </div>
                %
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-2">
            <div
              class="row mx-0 internal-border-new rounded-10 px-2 pt-2"
              style="background-color:white"
            >
              {{ $t("show") }} {{ $t("days") }}:
              <b-form-checkbox
                v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                :key="weekdaysKey"
                v-model="weekDays[weekdaysKey]"
                class="j-checkbox mx-2 mb-2 pb-0"
                @change="onChangeWeekdays($event, weekdaysKey)"
              >
                <div class="text-capitalize">{{ weekdaysKey }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message">
              <span>{{ $t(weekdayerror) }}</span>
            </p>
          </div>

          <!-- <div class="col-lg-12 col-xl-12 align-self-center mb-3">
            <div class="row mx-0">
              {{ $t('Applicablefor') }}:
              <b-form-checkbox
                v-for="(applicable, applicableForKey) in applicableFor"
                :key="applicableForKey"
                v-model="applicableFor[applicableForKey]"
                class="j-checkbox mx-3 mb-3"
                @change="onChangeApplicable($event, applicableForKey)"
              >
                <div class="text-capitalize">{{ applicableForKey }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message">
              <span>
                {{ $t(applicableerror
                ) }}
              </span>
            </p>
          </div> -->

          <!-- <div class="col-lg-12 col-xl-12 align-self-center mb-4">
            <div class="row mx-0">
              {{ $t('vouchersissuedbypartnername') }} :
              <div class="dropdown-curve-container">
                <custommultiselect
                  v-model="vouchersConfigation.vp_id"
                  :options="voucherPartnerList"
                  placeholder="Select Partner"
                  label="vp_partner_name"
                  isSingleId="vp_id"
                  :multiple="false"
                  track-by="vp_id"
                ></custommultiselect>
              </div>
            </div>
          </div>-->

          <div class="col-lg-12 col-xl-12">
            <div class="d-flex">
              <div class="input-material-textarea">
                <textarea
                  v-model="vouchersObject.voucher_terms"
                  v-validate="'required'"
                  name="termsandco"
                  id="termsandco"
                  rows="5"
                  class="rounded-10"
                ></textarea>
                <label class="active">{{ $t("termsandconditions") }}</label>
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('termsandco')">{{
                errors.first("termsandco")
              }}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="section-title mb-4" style="font-size: 20px">
          {{ $t("voucher") }} {{ $t("split") }} {{ $tc("configuration", 1) }}
        </div>
        <!-- client_id -->
        <div class="row" style="height:35px">
          <div class="col-lg-6 col-xl-4 mb-2">
            <div class="dropdown-curve-container">
              <label
                :class="
                  vouchersObject.selectedClient.client_id &&
                  String(vouchersObject.selectedClient.client_id).length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("client") }}</label
              >
              <div class>
                <multiselect
                  v-model="vouchersObject.selectedClient"
                  :placeholder="$tc('client')"
                  :options="clientList"
                  @select="onSelectClient($event)"
                  label="client_name"
                  track-by="client_id"
                  :multiple="false"
                ></multiselect>
              </div>
            </div>
            <!-- <p class="error_message">
            <span v-if="submitted && vouchersObject.selectedClient.length == 0"
              >{{ $tc("Please_select_client") }}.</span
            >
          </p> -->
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-2 ">
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ $tc("share") }} {{ $tc("value") }}</span>
              <div class="input-material-sm mx-2">
                <input
                  style="text-align:right;"
                  v-model="vouchersObject.share_value"
                  v-validate=""
                  name="share_value"
                  id="share_value"
                  type="text"
                />
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('share_value')">{{
                errors.first("share_value")
              }}</span>
            </p>
          </div>

          <!-- IS PERCENTAGE -->
          <div class="col-lg-6 col-xl-4 align-self-center mb-2">
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ $t("isPercentage") }}</span>
              <b-form-checkbox
                class="ml-3 j-checkbox pb-0"
                v-model="vouchersObject.share_is_percentage"
                unchecked-value="N"
                value="Y"
                disabled
              ></b-form-checkbox>
            </div>
            <p class="error_message"></p>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4 text-center">
        <button
          :disabled="btenable"
          @click.prevent.stop="OnFinalSubmit(true)"
          class="btn-blue"
        >
          {{ $t("generate") }} {{ $t("voucher") }}
        </button>
        <button
          :disabled="btenable"
          @click.prevent.stop="OnFinalSubmit(false)"
          class="btn-blue"
        >
          {{ $t("generatemorevouchers") }}
        </button>
      </div>
    </div>

    <b-modal
      id="view-voucher-codes-modal"
      title="View All Voucher Codes"
      ok-only
    >
      <div class="row">
        <div
          v-for="(VoucherCode,
          VoucherCodeIndex) in vouchersObject.voucher_code_list"
          :key="VoucherCodeIndex"
          class="col-md-4 mb-3"
        >
          <p>{{ VoucherCode }}</p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import { generateRandomCode } from "@/helper/collection";
import MasterService from "@/services/MasterService";
import scheduleService from "@/services/scheduleService";
import MovieService from "@/services/MovieService";
import MarketingService from "@/services/MarketingService";
import ClientService from "@/services/ClientService";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

let Start_Date = moment(
  `${moment()
    .subtract(1, "days")
    .format("YYYY-MM-DD")} 24:00:00`
).format();
let End_date = moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).format();

export default {
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      TicketTypes: [],
      messagetickettype: "Please Select Ticket Type",
      btenable: false,
      // Saif
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      submitted: false,
      clientList: [],
      cinemasList: [],
      movieList: [],
      ScreenList: [],
      Cinemas: [],
      voucherPartnerList: [],
      multipleVouchersCode: {
        noOfVouchers: 10,
        prefixText: "",
        isRandom: true,
        voucherCodeLength: 8,
        sequenceStart: generateRandomCode(8),
      },
      selectedCinemaScreenSeatClassList: [
        {
          cine_id: null,
          screen_id: null,
          sst_id: null,
          tt_id: null,
          cinemasList: [],
          screenList: [],
          seatClassList: [],
        },
      ],
      vouchersObject: {
        generateMultipleCode: false,
        voucher_code_list: ["VO-" + generateRandomCode(8)],
        voucher_code: "VO-" + generateRandomCode(8),
        voucher_title: null,
        voucher_description: null,
        voucher_receipt_name: null,
        is_code_required: "Y",
        add_in_revenue: "N",
        is_share_with_distributor: "N",
        cine_id: null,
        selectedCinemasList: [],
        selectedCinema: null,
        md_id: null,
        selectedMoviesList: [],
        selectedMovie: null,
        voucher_start_date_time: Start_Date,
        voucher_end_date_time: null, // End_date,
        voucher_terms: null,
        voucher_is_active: "Y",
        startTime2: "00:00",
        endTime2: "23:59",
        voucher_redemption_percent_fnb: 0,
        client_id: null,
        selectedClient: [],
        share_value: null,
        share_is_percentage: "Y",
        ticket_type_selected: "",
        tt_id: null,
        is_complimentary_ticket: "N",
        is_open_voucher: "N",
        is_allow_cash_refund: "N",
        selectedCinemaComplimentory: "",
        selectedScreen: "",
        cinema_id: null,
        screen_id: null,
        voucher_for_specific_seat_type: "N",
      },
      isValueVoucher: "Y",
      vouchersConfigation: {
        vs_redeem_at_boxoffice: true,
        vs_redeem_at_concession: false,
        vs_redeem_at_online: false,

        voucherPartnerName: null,
        vp_id: null,
        noOfVoucher: null,
        amount: null,
        redemptionStartDateTime: null,
        redemptionEndDateTime: null,

        voucher_amount: null,
        voucher_buy_no_of_ticket: null,
        voucher_get_free_ticket: null,
        voucher_is_percentage: "Y",
        voucher_min_redemption_amount: null,
        voucher_max_redemption_amount: null,
        voucherRedeemAmount: "voucherRedeemGrossAmount",
        voucher_redemption_per_patron: null,
        voucher_total_redemption: null,
      },
      weekDays: {
        selectAll: true,
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
      },

      applicableFor: {
        // all: false,
        prebook: true,
        normal: false,
      },
      weekdayerror: "",
      reedemerror: "",
      applicableerror: "",
      hideComplemetory: true,

      // Saif
    };
  },
  computed: {
    showConfiguration() {
      if (
        this.vouchersObject.is_open_voucher == "Y" ||
        this.vouchersObject.is_complemetory_ticket == "Y"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    // "weekDays.selectAll"(newVal, oldVal) {
    //   if (newVal) {
    //     Object.keys(this.weekDays).map(x => {
    //       x !== "selectAll" ? (this.weekDays[x] = true) : "";
    //     });
    //   } else if (!newVal) {
    //     Object.keys(this.weekDays).map(x => {
    //       x !== "selectAll" ? (this.weekDays[x] = false) : "";
    //     });
    //   }
    // },
    // "applicableFor.all"(newVal, oldVal) {
    //   if (newVal) {
    //     Object.keys(this.applicableFor).map(x => {
    //       x !== "all" ? (this.applicableFor[x] = true) : "";
    //     });
    //   } else if (!newVal) {
    //     Object.keys(this.applicableFor).map(x => {
    //       x !== "all" ? (this.applicableFor[x] = false) : "";
    //     });
    //   }
    // }
  },
  beforeMount() {
    this.getCinemasList();
    this.getActiveMovies();
    this.getClientList();
    this.getActiveVoucherPartners();
    this.getTicketTypeList();
  },
  mounted() {},

  methods: {
    onChangeCinemaSpecificValue(event) {
      console.log("onChangeCinemaSpecificValue", event);
      this.vouchersObject["selectedCinemasList"] = [];
      if (event == "Y") {
        let tempObj = {
          cine_id: null,
          cine_name: "",
          screen_id: null,
          sst_id: null,
          tt_id: null,
          cinemasList: [],
          screenList: [],
          seatClassList: [],
        };
        this.vouchersObject["selectedCinemasList"].push(tempObj);
        this.$forceUpdate();
        console.log(
          "this.vouchersObject[selectedCinemasList]",
          this.vouchersObject["selectedCinemasList"]
        );
      } else {
        this.vouchersObject["selectedCinemasList"] = [];
      }
    },
    handleComplimetoryChange(event) {
      console.log("handleComplimetoryChange", event);
      if (event == "N") {
        this.vouchersObject.ticket_type_selected = "";
        this.vouchersObject.selectedCinemaComplimentory = "";
        this.vouchersObject.selectedScreen = "";
        this.vouchersObject.cinema_id = null;
        this.vouchersObject.screen_id = null;
        this.vouchersObject.tt_id = null;
      }
    },
    onSelectComplimetoryCinema(cinema) {
      this.vouchersObject.selectedScreen = "";
      this.vouchersObject.screen_id = null;
      this.vouchersObject.selectedCinemaComplimentory = cinema;
      this.vouchersObject.cinema_id = cinema.cine_id;
      let cinemaId = cinema.cine_id;
      this.getScreenList(cinemaId);
    },
    onSelectScreen(screen) {
      this.vouchersObject.selectedScreen = screen;
      this.vouchersObject.screen_id = screen.screen_id;
    },
    getScreenList: function(cinema_id, Indexx = null) {
      console.log("cinema_id :", cinema_id);
      if (Indexx || Indexx == 0) {
        this.vouchersObject["selectedCinemasList"][Indexx].screenList = [];
        this.vouchersObject["selectedCinemasList"][Indexx].screen_id = null;

        this.vouchersObject["selectedCinemasList"][Indexx].seatClassList = [];
        this.vouchersObject["selectedCinemasList"][Indexx].sst_id = null;
      } else {
        this.ScreenList = [];
      }
      if (cinema_id) {
        let payload = {
          cinema_id: cinema_id,
        };
        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              if (Indexx || Indexx == 0) {
                this.vouchersObject["selectedCinemasList"][
                  Indexx
                ].screenList = data.Records.filter(
                  (x) => x.screen_seat_types.length > 0
                );
              } else {
                this.ScreenList = data.Records.filter(
                  (x) => x.screen_seat_types.length > 0
                );
              }
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      }
    },
    getSeatClassList: function(screen_id, Indexx) {
      this.vouchersObject["selectedCinemasList"][Indexx].sst_id = null;
      this.vouchersObject["selectedCinemasList"][Indexx].seatClassList = [];

      if (screen_id) {
        let payload = {
          tableName: "screen_seat_type",
          screen_id: screen_id,
          sst_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                // this.seatClassList = data.Records;
                this.vouchersObject["selectedCinemasList"][
                  Indexx
                ].seatClassList = data.Records;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      }
    },
    onChangeCodeRequired(event) {
      console.log("event", event);
      if (event == "N") {
        this.vouchersObject.generateMultipleCode = false;
      }
    },
    onchangeOpenVoucher(event) {
      console.log("onchangeOpenVoucher", event);
      if (event == "Y") {
        this.hideComplemetory = false;
        // this.vouchersObject.is_code_required = "Y";
      } else if (event == "N") {
        this.hideComplemetory = true;
      }
    },
    // SAIF
    // onChangeTime(event, type) {
    //   if(type == 'startTime') {
    //     const fullDate = this.vouchersObject.voucher_start_date_time
    //     const time = event.displayTime;
    //     const d = moment(fullDate).format('L');
    //     const date = moment(d +' '+ time).format();
    //     this.vouchersObject.voucher_start_date_time = date;
    //   } else if( type == 'endTime') {
    //     const fullDate = this.vouchersObject.voucher_end_date_time
    //     const time = event.displayTime;
    //     const d = moment(fullDate).format('L');
    //     const date = moment(d +' '+ time).format();
    //     this.vouchersObject.voucher_end_date_time = date
    //   }
    // },
    OnChangeMultipleCodeGenerate: function(event) {
      if (
        this.vouchersObject.generateMultipleCode &&
        this.vouchersObject.voucher_code_list.length > 1
      ) {
        this.vouchersObject.voucher_code_list = [];
        this.vouchersObject.voucher_code_list[0] = `VO-${generateRandomCode(
          8
        )}`;
      }
      console.log("OnChangeMultipleCodeGenerate EVENT", event);

      if (event) {
        this.vouchersConfigation["voucher_redemption_per_patron"] = 1;
        this.vouchersConfigation["voucher_total_redemption"] = 1;
      } else {
        this.vouchersConfigation["voucher_redemption_per_patron"] = null;
        this.vouchersConfigation["voucher_total_redemption"] = null;
      }
    },
    selectTicketType(tt, Indexx = null) {
      if (Indexx || Indexx == 0) {
        this.vouchersObject["selectedCinemasList"][Indexx].tt_id = tt.tt_id;
      } else {
        this.vouchersObject.tt_id = tt.tt_id;
      }
    },
    addMoreCinemasScreenSeatClass: function() {
      this.vouchersObject["selectedCinemasList"].push({
        cine_id: null,
        screen_id: null,
        sst_id: null,
        tt_id: null,
        cinemasList: this.cinemasList,
        screenList: [],
        seatClassList: [],
      });
    },
    removeCinemasScreenSeatClass: function(index) {
      this.vouchersObject["selectedCinemasList"].splice(index, 1);
    },
    getTicketTypeList: function() {
      this.TicketTypes = [];
      let body = {
        tableName: "ms_ticket_type",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.TicketTypes = data.Records.filter((x) => {
              return x.tt_is_active == "Y";
            });
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    onSelectClient: function(client) {
      this.vouchersObject.client_id = client.client_id;
    },
    onGenerateMultipleVouchers: function() {
      let loader = this.$loading.show();

      this.vouchersObject.voucher_code_list = [];
      for (let i = 0; i < this.multipleVouchersCode.noOfVouchers; i++) {
        // const element = array[i];
        if (i === 0) {
          this.vouchersObject.voucher_code_list.push(
            `${this.multipleVouchersCode.prefixText}-${this.multipleVouchersCode.sequenceStart}`
          );
        } else if (this.multipleVouchersCode.isRandom) {
          this.vouchersObject.voucher_code_list.push(
            `${this.multipleVouchersCode.prefixText}-${generateRandomCode(
              parseInt(this.multipleVouchersCode.voucherCodeLength)
            )}`
          );
        } else if (!this.multipleVouchersCode.isRandom) {
          let num = parseInt(this.multipleVouchersCode.sequenceStart) + i;
          this.vouchersObject.voucher_code_list.push(
            `${this.multipleVouchersCode.prefixText}-${num}`
          );
        }
        if (
          this.vouchersObject.voucher_code_list.length ===
          this.multipleVouchersCode.noOfVouchers
        ) {
          setTimeout(() => loader.hide(), 1100);
        }
      }
      // console.log("this.voucher_code_list :", this.vouchersObject.voucher_code_list);
    },
    onChangeWeekdays: function(event, keyname) {
      this.weekdayerror = "";
      // console.log("event :", event);
      if (keyname !== "selectAll") {
        this.weekDays["selectAll"] = false;
      }
      let len = Object.keys(this.weekDays).length;
      if (keyname === "selectAll" && event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "selectAll" ? (this.weekDays[x] = true) : "";
        });
      } else if (keyname === "selectAll" && !event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "selectAll" ? (this.weekDays[x] = false) : "";
        });
      } else if (keyname !== "selectAll" && this.weekDays.selectAll) {
        this.weekDays["selectAll"] = false;
      }
    },
    onChangeApplicable: function(event, keyname) {
      this.applicableerror = "";
      // if (keyname !== "all") {
      //   this.applicableFor["all"] = false;
      // }
      // let len = Object.keys(this.applicableFor).length;
      // if (keyname === "all" && event) {
      //   Object.keys(this.applicableFor).map(x => {
      //     x !== "all" ? (this.applicableFor[x] = true) : "";
      //   });
      // } else if (keyname === "all" && !event) {
      //   Object.keys(this.applicableFor).map(x => {
      //     x !== "all" ? (this.applicableFor[x] = false) : "";
      //   });
      // } else if (keyname !== "all" && this.applicableFor.all) {
      //   this.applicableFor["all"] = false;
      // }
    },
    onChangeReedem: function() {
      this.reedemerror = "";
    },
    onChangeSwitch: function(event) {
      console.log("event :>> ", event);
      if (event == "N") {
        this.vouchersConfigation.vs_redeem_at_concession = false;
      }
    },
    getCinemasList: function() {
      this.cinemasList = [];
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              // this.cinemasList = data.Records;
              data.Records.forEach((cine) => {
                cine["screen_id"] = null;
                cine["sst_id"] = null;
                cine["tt_id"] = null;
                cine["screenList"] = [];
                cine["seatClassList"] = [];
              });
              this.Cinemas = data.Records;
              this.cinemasList = [
                {
                  label: "Select All Cinemas",
                  Cinemas: data.Records,
                },
              ];
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    getClientList() {
      ClientService.GetAllClients({})
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.clientList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getActiveMovies: function() {
      this.movieList = [];
      MovieService.GetActiveMoviesWithFormat({ movieversions: "Y" })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              // this.movieList = data.Records;
              this.movieList = [
                {
                  label: "Select All Movies",
                  Movies: data.Records,
                },
              ];
            }
          } else {
            // Show Error Message
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    getActiveVoucherPartners: function() {
      this.voucherPartnerList = [];
      MarketingService.GetVoucherPartners()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            data.Records.length > 0
              ? (this.voucherPartnerList = data.Records)
              : "";
          } else {
            // Show Error Message
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    convertTime(date, time) {
      // const d = moment(date).format("L");
      const d = moment(date).format("YYYY-MM-DD");
      const newdate = moment(d + " " + time).format();
      return newdate;
    },
    OnFinalSubmit: function(flag) {
      // console.log("this.weekDays :", this.weekDays);
      this.submitted = true;
      if (
        !this.weekDays.selectAll &&
        Object.keys(this.weekDays).filter(
          (x) => x !== "selectAll" && this.weekDays[x]
        ).length === 0
      ) {
        this.weekdayerror = "weekdaymsg";
      } else if (
        this.vouchersObject.share_is_percentage == "Y" &&
        this.vouchersObject.share_value > 100
      ) {
        return this.$toasted.show("Share value can not be more than 100");
      } else {
        this.weekdayerror = "";
        if (
          this.vouchersConfigation.vs_redeem_at_boxoffice === false &&
          this.vouchersConfigation.vs_redeem_at_concession === false &&
          this.vouchersConfigation.vs_redeem_at_online === false
        ) {
          this.reedemerror = "redeematmsg";
        } else {
          this.reedemerror = "";
          if (
            !this.applicableFor.all &&
            Object.keys(this.applicableFor).filter(
              (x) => x !== "all" && this.applicableFor[x]
            ).length === 0
          ) {
            this.applicableerror = "applicablemsg";
          } else {
            this.applicableerror = "";
            this.$validator.validate().then((valid) => {
              let cinemaCheck = 0;

              if (this.vouchersObject.selectedCinemasList.length == 0) {
                cinemaCheck++;
              } else {
                this.vouchersObject.selectedCinemasList.forEach((x) => {
                  if (!x.cine_id) {
                    cinemaCheck++;
                  }
                });
              }

              if (cinemaCheck > 0) {
                return this.$toasted.show("Please Select Cinema");
              }

              if (
                this.isValueVoucher == "N" &&
                this.showConfiguration &&
                this.vouchersConfigation.voucher_max_redemption_amount <
                  this.vouchersConfigation.voucher_get_free_ticket
              ) {
                return this.$toasted.show(
                  "Maximum free tickets must be greater or equals to offer free tickets"
                );
              }
              if (
                this.vouchersObject.is_complimentary_ticket == "Y" &&
                !this.vouchersObject.ticket_type_selected
              ) {
                return;
              }
              if (valid) {
                if (!this.vouchersObject.voucher_start_date_time) {
                  return this.$toasted.show("Please Enter Start Date");
                } else if (
                  !this.vouchersObject.voucher_end_date_time &&
                  false
                ) {
                  return this.$toasted.show("Please Enter End Date");
                } else if (
                  new Date(
                    moment(this.vouchersObject.voucher_end_date_time).format(
                      "YYYY-MM-DD"
                    )
                  ) &&
                  new Date(
                    moment(this.vouchersObject.voucher_start_date_time).format(
                      "YYYY-MM-DD"
                    )
                  ) >
                    new Date(
                      moment(this.vouchersObject.voucher_end_date_time).format(
                        "YYYY-MM-DD"
                      )
                    )
                ) {
                  return this.$toasted.show(
                    "From date should not be greater than To date."
                  );
                } else {
                  if (
                    this.vouchersObject.startTime2 &&
                    this.vouchersObject.endTime2
                  ) {
                    console.log(
                      this.vouchersObject.voucher_start_date_time,
                      this.vouchersObject.startTime2
                    );
                    this.vouchersObject.voucher_start_date_time = this.convertTime(
                      this.vouchersObject.voucher_start_date_time,
                      this.vouchersObject.startTime2
                    );
                    if (this.vouchersObject.voucher_end_date_time) {
                      this.vouchersObject.voucher_end_date_time = this.convertTime(
                        this.vouchersObject.voucher_end_date_time,
                        this.vouchersObject.endTime2
                      );
                    }
                  }
                }

                if (this.isValueVoucher == "N") {
                  this.vouchersConfigation.voucher_is_percentage = "N";
                }
                let loader = this.$loading.show();
                this.btenable = true;
                if (
                  this.vouchersObject["is_open_voucher"] == "Y" &&
                  this.vouchersObject["is_complimentary_ticket"] == "N"
                ) {
                } else {
                  this.vouchersObject["is_allow_cash_refund"] = "N";
                }
                let payload = {
                  isValueVoucher: this.isValueVoucher,
                  ...this.vouchersObject,
                  vouchersConfigation: this.vouchersConfigation,
                  ...this.vouchersConfigation,
                  weekDays: this.weekDays,
                  ...this.applicableFor,
                  multipleVouchersCode: this.multipleVouchersCode,
                };

                MarketingService.AddVochers(payload)
                  .then((response) => {
                    this.btenable = false;
                    loader.hide();
                    const { data } = response;
                    if (data && data.status) {
                      // data.Records.length > 0
                      this.$toasted.show(
                        data.message || "Voucher added successfully"
                      );

                      this.resetHandler();
                      if (flag) {
                        this.$router.push({
                          path: "/marketing/vouchers",
                        });
                      }
                    } else {
                      // Show Error Message
                      this.$toasted.show(data.message || this.AdminError);
                    }
                  })
                  .catch((err) => {
                    loader.hide();
                    this.btenable = false;
                  });
              }
            });
          }
        }
      }
    },
    resetHandler: function() {
      (this.submitted = false),
        (this.vouchersObject = {
          generateMultipleCode: false,
          voucher_code_list: ["VO-" + generateRandomCode(8)],
          voucher_code: "VO-" + generateRandomCode(8),
          voucher_title: null,
          voucher_description: null,
          voucher_receipt_name: null,
          is_code_required: "Y",
          add_in_revenue: "N",
          is_share_with_distributor: "N",
          cine_id: null,
          selectedCinemasList: [],
          selectedCinema: null,
          md_id: null,
          selectedMoviesList: [],
          selectedMovie: null,
          voucher_start_date_time: Start_Date,
          voucher_end_date_time: null, // End_date,
          voucher_terms: null,
          voucher_is_active: "Y",
          startTime2: "00:00",
          endTime2: "23:59",
          voucher_redemption_percent_fnb: 0,
          client_id: null,
          selectedClient: [],
          share_value: null,
          share_is_percentage: "Y",
          ticket_type_selected: "",
          tt_id: null,
          is_complimentary_ticket: "N",
          is_open_voucher: "N",
          is_allow_cash_refund: "N",
          selectedCinemaComplimentory: "",
          selectedScreen: "",
          cinema_id: null,
          screen_id: null,
          voucher_for_specific_seat_type: "N",
        });
      this.vouchersConfigation = {
        voucher_buy_no_of_ticket: null,
        voucher_get_free_ticket: null,
        vs_redeem_at_boxoffice: true,
        vs_redeem_at_concession: false,
        vs_redeem_at_online: false,

        voucherPartnerName: null,
        vp_id: null,
        noOfVoucher: null,
        amount: null,
        redemptionStartDateTime: null,
        redemptionEndDateTime: null,

        voucher_amount: null,
        voucher_is_percentage: "Y",
        voucher_min_redemption_amount: null,
        voucher_max_redemption_amount: null,
        voucherRedeemAmount: "voucherRedeemGrossAmount",
        voucher_redemption_per_patron: null,
        voucher_total_redemption: null,
      };
      this.weekDays = {
        selectAll: true,
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
      };

      this.applicableFor = {
        // all: false,
        prebook: true,
        normal: false,
      };
    },
    // SAIF
  },
};
</script>
<style>
.custom-date .btn-clearDate {
  right: 30px !important;
}
.customDisabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.new-border {
  border: 2px solid #b1b4b8;
}
label {
  color: black !important;
}
.internal-border-new {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
}
.internal-border {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 0 15px 15px 15px;
  padding-top: 15px;
  width: 100%;
}
.back {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/VouchersComponent/addVouchers.vue